/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

const styles = {
  suggestionTitle: css`
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: var(--cds-color-grey-800);
  `,
};

type Props = React.PropsWithChildren;

export type CoachSuggestionTitleComponent = React.ReactElement<Props>;

const CoachSuggestionTitle = ({ children }: Props) => {
  return (
    <Typography2 variant="bodySecondary" component="div" css={styles.suggestionTitle}>
      {children}
    </Typography2>
  );
};

export default CoachSuggestionTitle;
